<template>
  <v-layout class="row-message" ma-2 grow
    :class="'content-type-' + event.content_type"
  >
    <v-layout v-if="event.content_type == 'sticker'" column>
      <div style="
          width: 100px;
          max-height: 100px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          max-width: 100%;
          margin-bottom: 10px;
          border-radius: 4px;
        ">
        <viewer style="display: flex"
          :images="[event.content.url]"
          :options="{ movable: true, title: false, navbar: false }">
          <img v-for="src in [event.content.url]" :src="src"
            :key="src" style="width: 100%; cursor: pointer" />
        </viewer>
      </div>
    </v-layout>
    <v-card v-else class="message" :class="`${this.$vuetify.theme.dark ? 'secondary-background' : 'primary-background'}`" >
      <v-layout grow > 
        <v-layout class="box-message" column>
          <div style="display: flex; flex-direction: row; align-items: center;">
            <v-layout class="dont-break-out">
              <v-flex v-if="event.content">
  
                <v-layout v-if="event.content_type == 'image'" column>
                  <div style="
                      width: 330px;
                      max-height: 330px;
                      overflow: hidden;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: relative;
                      max-width: 100%;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    ">
                    <viewer style="display: flex"
                      :images="[event.content.url]"
                      :options="{ movable: true, title: false, navbar: false }">
                      <img v-for="src in [event.content.url]"
                        :src="src" :key="src"
                        style="width: 100%; cursor: pointer" />
                    </viewer>
                  </div>
                  <span v-if="event.content.caption">{{
                    event.content.caption
                  }}</span>
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'ptt'" column>
                  <audio-player :file="event.content.url">
                  </audio-player>
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'audio'"
                  column>
                  <audio-player :file="event.content.url"
                    :showSpeed="event.content?.transcription"
                  >
                  </audio-player>
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'text' || event.content_type == 'click'"
                  column>
                  <span>
                    <v-tooltip
                      v-if="event.content_type == 'click'"
                      bottom
                    >
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <v-icon>reply</v-icon>
                        </span>
                      </template>
                      Resposta rápida
                    </v-tooltip>

                    {{ event.content.text }}
                  </span>
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'video'"
                  column>
                  <video v-show="event.content.url" width="300"
                    height="300" controls
                    style="outline: none; margin-bottom: 10px; border-radius: 4px">
                    <source :src="event.content.url"
                      type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'document'"
                  column>
                  <div
                    v-if="checkDocType(event.content.caption, ['pdf'])"
                    style="
                      width: 330px;
                      max-height: 330px;
                      overflow: hidden;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: relative;
                      max-width: 100%;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    ">
                    <div class="pdfPreview"
                      v-for="src in [event.content.url]" :src="src"
                      :key="src">
                      <a @click="viewPdf(src)">
                        <span>
                          <object :data="src" type="application/pdf"></object>
                        </span>
                      </a>
                    </div>
                  </div>
                  <v-layout ma-1 align-center>
                    <div style="height: 33px">
                      <img v-if="
                          checkDocType(event.content.caption, ['pdf'])
                        " style="height: 100%" src="icon_pdf.png" />
                      <img v-else-if="
                          checkDocType(event.content.caption, [
                            'rtf',
                            'doc',
                            'docx',
                          ])
                        " style="height: 100%" src="icon_doc.png" />
                      <img v-else-if="
                          checkDocType(event.content.caption, [
                            'xls',
                            'xlsx',
                            'csv',
                          ])
                        " style="height: 100%" src="icon_sheet.png" />
                      <img v-else style="height: 100%" src="icon_file.png" />
                    </div>
  
                    <span class="mr-1 ml-2">{{
                      event.content.caption
                    }}</span>
  
                    <v-btn outlined icon color="#848484" @click="
                        downloadUri({ url: event.content.url, file_name: event.content.file_name || event.content.caption })
                      ">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="checkDocType(event.content.caption, ['pdf'])"
                      outlined icon color="#848484"
                      @click="viewPdf(event.content.url)">
                      <v-icon>preview</v-icon>
                    </v-btn>
                  </v-layout>
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'contact'"
                  class="message-content">
                  <v-icon>account_circle</v-icon>
                  Contato
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'location'"
                  class="message-content">
                  <v-icon>place</v-icon>
                  Localização
                </v-layout>
  
                <v-layout v-else-if="event.content_type == 'unsupported'"
                  class="message-content">
                  <v-icon>error</v-icon>
                  Formato da mensagem não suportado
                </v-layout>
  
                <v-layout v-else column>
                  {{ event.content }}
                </v-layout>

                <v-layout
                  v-if="event.content?.transcription"
                  class="transcription"
                >
                  "{{ event.content.transcription }}"
                </v-layout>
              </v-flex>
            </v-layout>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon style="font-size: 30px; " color="grey darken-1">
                    keyboard_arrow_down
                  </v-icon>
                </v-btn>
              </template>
              <v-list
                :class="`${
                  this.$vuetify.theme.dark
                    ? 'tertiary-background'
                    : 'secondary-background'
                }`"
              >
                <v-list-item
                  v-if="event.content_type == 'text' || event.content_type == 'quick_reply'"
                  @click="messageToReply(event.content.text)"
                >
                  <v-list-item-icon>
                    <v-icon>reply</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Responder
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="`/search?q=${event.sender}`"
                  target="_blank"
                >
                  <v-list-item-icon>
                    <img
                      src="https://dodo.gorillascode.com/favicon.ico"
                      alt="Dodo"
                      style="width: 20px; height: 20px;"
                    />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Pesquisar conversas no Dodo</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  :href="`https://chatwoot.quiteja.com.br/app/accounts/2/search/conversations?q=%2B55${event.sender}`"
                  target="_blank"
                >
                  <v-list-item-icon>
                    <img
                      src="https://chatwoot.quiteja.com.br/favicon-32x32.png"
                      alt="Chatwoot"
                      style="width: 20px; height: 20px;"
                    />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Pesquisar conversas no Chatwoot</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-layout align-end>
            <v-layout
              @click="copyPhoneNumberToClipboard()"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span class="from-number" v-on="on">
                    {{ event.sender | phoneNumber }}
                  </span>
                </template>
                <span>Clique para copiar</span>
              </v-tooltip>
            </v-layout>

            <v-layout shrink>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span class="date-event" v-on="on">{{
                    (event.created_at) | moment("from", "now")
                  }}</span>
                </template>
                <span>{{
                  (event.created_at) | moment("DD/MM/YYYY HH:mm:ss")
                }}</span>
              </v-tooltip>
            </v-layout>
          </v-layout>
        </v-layout>

        <v-layout>
          <eval-intent :message="event"
            @assignConversation="assignConversation">
          </eval-intent>
        </v-layout>
      </v-layout>
    </v-card>

    <v-spacer v-if="!debug"></v-spacer>
    <previewPDF ref="previewPDF"></previewPDF>
  </v-layout>
</template>

<script>
import previewPDF from "./previewPDF"
import EvalIntent from './EvalIntent'
import AudioPlayer from '@/components/Common/AudioPlayer'

import { mapActions, mapGetters, mapMutations } from "vuex"
import { replyText } from "@/pages/CustomerServiceRasa/store/rasaReplyMessage.module"

export default {
  setup() {
    const messageToReply = (message) => {
      message = message.replace(/^\n+/g, '').replace(/\n+$/g, '');
      message = message.replace(/\n+/g, '\n');

      message = message
                  .split('\n')
                  .filter(linha => !linha.trim().startsWith('>'))
                  .map(linha => `> ${linha}`)
                  .join('\n');
      
      message += '\n';
      replyText.value = message
    }

    return {
      messageToReply,
    };
  },
  props: ['event', 'debug'],
  components: {
    EvalIntent,
    AudioPlayer,
    previewPDF,
  },
  data() {
    return {
      readNow: false
    }
  },

  computed: {
    ...mapGetters('rasaConversation', {
      currentConversation: 'currentConversation',
    }),
  },

  methods: {
    ...mapActions("rasaUpload", {
      downloadUri: "download",
    }),

    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),

    async copyPhoneNumberToClipboard() {
      if (!this.event.sender) {
        return;
      }

      try {
        await navigator.clipboard.writeText(this.event.sender);
        this.showSnackbar('Número de telefone copiado');
      } catch (err) {
        console.error('Não foi possível copiar o número de telefone', err);
        this.showSnackbar('Não foi possível copiar o número de telefone');
      }
    },

    viewPdf(src) {
      this.$refs.previewPDF.open(src);
      this.$refs.previewPDF.dialog = true;
    },
    assignConversation() {
      this.$emit('assignConversation')
    },
    checkDocType(file_name, types) {
      let name_splitted = file_name.split('.')
      let type = name_splitted[name_splitted.length - 1]
      return types.indexOf(type) > -1
    },
  },
}
</script>

<style lang="scss" scoped>
.row-message {
  max-height: max-content;
  padding: 0;

  .message {
    border-radius: 12px 12px 12px 0;

    display: flex;
    align-self: flex-start;
     z-index: 100;

    .box-message {
      padding: 8px 12px;
      border-radius: 12px 12px 12px 0;
      z-index: 100;
      min-width: 240px;
      max-width: 440px;

      .dont-break-out {
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
      }

      .transcription {
        color: gray;
        margin-bottom: 8px;
      }

      &.debug {
        border-radius: 12px 12px 0 12px;
      }
    }

    .from-number {
      cursor: pointer;
      font-weight: 400;
      line-height: 18px;
      font-size: 12px;
      color: gray;
    }

    .date-event {
      color: gray;
      font-size: 12px;
      margin-left: 10px;
    }

    .box-status {
      min-width: 17px;
      margin-top: -5px;
    }

    &.debug {
      border-radius: 12px 12px 0 12px;
    }
  }

  .shorcut-message {
    min-width: 40px;

    .btn-shortcut {
      opacity: 0;
    }

    &:hover {
      .btn-shortcut {
        opacity: 1;
      }
    }
  }

  &.content-type {
    &-contact,
    &-location,
    &-unsupported {
      .message-content {
        align-items: center;
        color: gray;
        font-style: italic;
        justify-content: flex-start;

        .v-icon {
          background-color: #9e9e9e;
          border-radius: 50%;
          color: white !important;
          margin-right: 8px;
          padding: 4px;
        }
      }
    }
  }
}
</style>
